import _ from 'lodash'

/**
 * Exports of tabular scorecard data (i.e. metrics) require certain raw data
 * along with the formatting so that excel formula's can be properly generated.
 *
 * @param item a scorecard item returned by the API Server
 * @return {object} Contains the attributes required for export (precision, currencyType, etc)
 * along with a property for each period that maps to the score for the
 * given period.
 */
export default function(item) {
	var metricData =  _.reduce(item.scores, function(periodIdToScore, s) {
		const scoreData = periodIdToScore[s.periodId] = s
		_.each(s.thresholds, (t,i) => {
			const value = _.isNil(t) ? '' : t
			scoreData[`threshold_${i}`] = value
		})
		return periodIdToScore
	}, {})
	metricData.dataType = item.dataType
	metricData.currencyCode = item.currencyCode
	metricData.precision = item.precision
	metricData.weight = item.weight
	metricData.impact = item.impact
	metricData.editable = item.editable
	return metricData
}
